<template>
  <img src="@/assets/img/Icons/segment-refresh.svg" />
</template>

<script>
export default {};
</script>

<style></style>
